export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export function difference(objA, objB) {
  return Object.fromEntries(
    Object.entries(objA).filter(([key]) => !Object.hasOwn(objB, key))
  );
}
export type Entries<T extends object> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

/**
 * A type-safe version of Object.entries().
 * It preserves the key types and the corresponding value types from the object.
 *
 * @example
 * const obj = { a: 1, b: "hello" };
 * const entries = entriesFromObject(obj);
 * // entries will be of type (['a', number] | ['b', string])[]
 * // instead of [string, any][]
 */
export function entriesFromObject<T extends object>(object: T): Entries<T> {
  return Object.entries(object) as Entries<T>;
}
